// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Lz43L","payMethod":"styles_payMethod__6UEay","current":"styles_current__mgPHe","payTitle":"styles_payTitle__ag8U-","iconPay":"styles_iconPay__eApsF"};